import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSearchForm, setErrorMessage } from '../../stories/actions';
import { getCreateUserEmailAndPassword } from '../../services/api';
import { isEmpty, phoneMask, isValidEmail, isValidPhone, isValidPasswd } from "../../utilities/methods";
import bcrypt from "bcryptjs-react";

import ButtonPay from '../Buttons/ButtonPay';
import Footer from '../Footer/Footer';

import "./Form.css";

const FormRegister = ({ users, setSearchFormAction, errorMessage, setErrorMessageAction }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [passwd, setPasswd] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [isShowPasswd, setIsShowPasswd] = useState(false);
    const [passwdType, setPasswdType] = useState("password");
    const [iconShowPasswd, setIconShowPasswd] = useState("visibility_off");

    const handlerPasswdType = () => {
        if (isShowPasswd) {
            setPasswdType("password");
            setIconShowPasswd("visibility_off");
        } else {
            setPasswdType("text");
            setIconShowPasswd("visibility");
        }

        setIsShowPasswd(!isShowPasswd);
    };

    const handlerHiddenPasswdType = () => {
        if (isShowPasswd) {
            setPasswdType("password");
            setIconShowPasswd("visibility_off");
        }

        setIsShowPasswd(!isShowPasswd);
    };

    const navigateTo = useNavigate();

    const handlerChangeName = (e) => {
        const value = e.target.value;
        setName(value);
    };

    const handlerChangeEmail = (e) => {
        const value = e.target.value;
        setEmail(value);
    };

    const handlerChangePhone = (e) => {
        let value = e.target.value;
        value = phoneMask(value);
        setPhone(value);
    };

    const handlerChangePasswd = (e) => {
        const value = e.target.value;
        setPasswd(value);
    };

    const handlerChangeChecked = (e) => {
        const value = e.target.checked;
        setIsChecked(value);
    };

    const handlerKeyPress = async (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            await handlerCreateUserEmailAndPassword();
        }
    };

    const handlerCreateUserEmailAndPassword = async () => {
        if (!isValidEmail(email)) {
            setErrorMessageAction("O endereço de e-mail fornecido não parece válido. o formato padrão (exemplo@dominio.com).");
        } else if (!isValidPhone(phone)) {
            setErrorMessageAction("O número de telefone informado não parece válido. tente por exemplo, (81912345678)");
        } else if (!isValidPasswd(passwd)) {
            setErrorMessageAction("A senha deve ter pelo menos 8 caracteres, incluindo uma letra maiúscula, um caractere especial e um número.");
        } else {
            if (!isEmpty(name) && !isEmpty(email) && !isEmpty(phone) && !isEmpty(passwd)) {
                const matchedUsers = await Promise.all(
                    users.map((user) => {
                        const isMatch = bcrypt.compare(passwd, user.senha);
                        return (user.email === email || user.telefone === phone) && isMatch ? user : null;
                    })
                );

                const user = matchedUsers.find(user => user !== null);

                if (user) {
                    setErrorMessageAction("Este usuário já existe!");
                } else {
                    const saltRounds = 10;
                    const hashPasswd = await bcrypt.hash(passwd, saltRounds);

                    await getCreateUserEmailAndPassword(name, email, phone, hashPasswd, true).then(() => {
                        handlerUserLogin();
                    });
                }
            }
        }
    };

    const handlerUserLogin = () => {
        setErrorMessageAction("");
        setSearchFormAction("login");
        navigateTo("/?page-login=true");
    };

    const handlerUserSendEmail = () => {
        setErrorMessageAction("");
        setSearchFormAction("sendemail");
        navigateTo("/?page-sendemail=true");
    };

    return (
        <div className='row'>
            <div className='col-md-3'></div>

            <div className='col-md-12 form_container'>
                <div className='form_card'>
                    <div className="mb-2">
                        <small className={errorMessage ? "label_form_style response_message" : "label_form_style"}>{errorMessage}</small>
                    </div>

                    <div className="mb-4">
                        <h4 className='label_form_title_paragraph'>Formulário de registro</h4>
                    </div>

                    <div className="mb-2 text-end">
                        <ButtonPay />
                    </div>

                    <div className="mb-2">
                        <label className="label_form_style">Nome</label>
                        <input type='text'
                            value={name}
                            placeholder='Seu Nome'
                            onChange={handlerChangeName}
                            onKeyDown={handlerKeyPress}
                            className='form-control input_theme_style' />
                    </div>

                    <div className="mb-2">
                        <label className="label_form_style">Email</label>
                        <input type='email'
                            value={email}
                            placeholder='nome@provedor.com'
                            onChange={handlerChangeEmail}
                            onKeyDown={handlerKeyPress}
                            className='form-control input_theme_style' />
                    </div>

                    <div className="mb-2">
                        <label className="label_form_style">Telefone</label>
                        <input type='tel'
                            value={phone}
                            placeholder='Telefone'
                            onChange={handlerChangePhone}
                            onKeyDown={handlerKeyPress}
                            className='form-control input_theme_style' />
                    </div>

                    <div className="mb-4">
                        <label className="label_form_style">Senha</label>
                        <div className='input_group_container'>
                            <input type={passwdType}
                                value={passwd}
                                placeholder='********'
                                onChange={handlerChangePasswd}
                                onKeyDown={handlerKeyPress}
                                className='form-control input_theme_style' />
                            <span className="material-symbols-outlined icon_visible_input_passwd"
                                onClick={handlerPasswdType}
                                onMouseOut={handlerHiddenPasswdType}>{iconShowPasswd}</span>
                        </div>
                    </div>

                    <div className="mb-4 col-md-6">
                        <div className='button_group_container' onClick={handlerCreateUserEmailAndPassword}>
                            <span className="button_group_paragraph_style">Salvar usuário</span>
                            <span className="material-symbols-outlined button_group_icon_style"> save </span>
                        </div>
                    </div>

                    <div className="mt-4 mb-2">
                        <div className='input_group_container'>
                            <input
                                type='checkbox'
                                checked={isChecked}
                                onChange={handlerChangeChecked}
                                className="input_check_style"
                            />
                            <span className="label_form_style">Aceito as políticas e os termos de serviço</span>
                        </div>
                    </div>

                    <div className="mb-2">
                        <span className='button_link_form_style' onClick={handlerUserLogin}>Tenho uma conta</span>
                    </div>

                    <div className="mb-2">
                        <span className='button_link_form_style' onClick={handlerUserSendEmail}>Esqueci minha senha</span>
                    </div>
                </div>
            </div>

            <div className='col-md-3'></div>

            <Footer />
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapActionToProps = (dispatch) => {
    return {
        setSearchFormAction: (searchForm) => dispatch(setSearchForm(searchForm)),
        setErrorMessageAction: (errorMessage) => dispatch(setErrorMessage(errorMessage))
    };
};

export default connect(mapStoreToProps, mapActionToProps)(FormRegister);